import { StyledButton } from '../Button';
import { styled } from '../../system';
import { wrapWithDefaultProps } from '../../lib/wrap-with-default-props';
export const ButtonGroup = wrapWithDefaultProps(styled('div', {
    h: 'min-content',
    display: 'inline-flex',
    bgColor: 'transparent',
    rounded: '$lg',
    [`& ${StyledButton}:focus`]: {
        zIndex: 1
    },
    variants: {
        flow: {
            row: { flexDir: 'row' },
            column: { flexDir: 'column' }
        }
    },
    compoundVariants: [
        {
            flow: 'row',
            css: {
                [`> ${StyledButton}`]: {
                    '&:not(:first-child)': {
                        ml: '-1px',
                        roundedL: '$none'
                    },
                    '&:not(:last-child)': {
                        roundedR: '$none'
                    }
                }
            }
        },
        {
            flow: 'column',
            css: {
                [`> ${StyledButton}`]: {
                    '&:not(:first-child)': {
                        mt: '-1px',
                        roundedT: '$none'
                    },
                    '&:not(:last-child)': {
                        roundedB: '$none'
                    }
                }
            }
        }
    ],
    defaultVariants: {
        flow: 'row'
    }
}), {
    flow: 'row'
});
ButtonGroup.displayName = 'ButtonGroup';
